import styled from '@emotion/styled';
import { useDetermineMobile } from '@myrealtrip/device-detect';

import Button from '../../../shared/designSystem/components/Button';
import { globalVariables } from '../../../shared/designSystem/constants';
import ChannelTalkPreviewButton from './ChannelTalkPreviewButton';
import { WeblogPageCategory, WeblogScreenName } from '../../../shared/constants/weblog';
import { sendClickLog } from '../../utils/sendClickLog';
import { useEnvContext } from '../../../modules/EnvProvider';
import DomainManager from '../../../shared/utils/DomainManager';

export default function CustomerCenter() {
  const { targetEnv } = useEnvContext();
  const domainManager = new DomainManager(targetEnv);
  const supportDomain = domainManager.getSupportDomain();
  const isMobile = useDetermineMobile();

  const handleChatClick = () => {
    sendClickLog({
      screenName: WeblogScreenName.COMMON,
      pageCategory: WeblogPageCategory.COMMON,
      eventName: 'footer',
      menuTitle: '고객지원실',
      targetUrl: supportDomain,
    });

    location.href = supportDomain;
  };

  const Container = isMobile ? MobileContainer : DesktopContainer;

  return (
    <Container>
      <Title>고객지원실 운영안내</Title>
      <InfoBox>
        <InfoText>{`채팅상담 연중무휴 24시간\n유선상담 연중무휴 09:00-18:00`}</InfoText>
        <InfoText>유선상담 1670-8208</InfoText>
      </InfoBox>
      <ChatButtonContainer>
        <ChatButton type="outline" onClick={handleChatClick}>
          고객지원실
        </ChatButton>
        <ChannelTalkPreviewButton />
      </ChatButtonContainer>
    </Container>
  );
}

const MobileContainer = styled.div`
  width: 100%;
`;

const DesktopContainer = styled.div`
  width: 50%;
`;

const Title = styled.span`
  font-size: 18px;
  font-weight: bold;
  color: ${globalVariables.gray_600};
  letter-spacing: 0;
`;

const InfoBox = styled.ul`
  margin-top: 10px;
`;

const InfoText = styled.li`
  font-size: 14px;
  letter-spacing: -0.2px;
  line-height: 1.5;
  word-break: break-all;
  color: ${globalVariables.gray_700};
  white-space: pre-wrap;
`;

const ChatButtonContainer = styled.div`
  display: flex;
  margin-top: 16px;
  gap: 6px;
`;

export const ChatButton = styled(Button)`
  button {
    width: 140px;
    height: 40px;
    font-size: 14px;
    padding: 9px 8px;
  }
`;
